import { REGEX_CONSTANT } from "../../../../constant/regexConstant";

export const validationDA = (namespace, data, translate) => {
  let error = {}

  switch (namespace) {
    case "first_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 50 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "last_name":
      if (data?.length > 50) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "nik":
      if (data?.length > 20 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 20", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.NIK.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "phone":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else if (data?.length > 13 || data?.length < 9) {
        error[namespace] = translate("Field cannot be less than 9 and more than 13", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "email":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.EMAIL.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null

      }
      break;

    case "emergency_contact_no_hp":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else if (data?.length > 13 || data?.length < 9) {
        error[namespace] = translate("Field cannot be less than 9 and more than 13", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;

    case "emergency_contact_address":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 100 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;

    case "country":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "district":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "sub_district":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "urban_village":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "address":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 100 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "neighbourhood":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 3 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "hamlet":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 3 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "postal_code":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "province":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "longitude":
      if (!REGEX_CONSTANT.LNG_LAT.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 30 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "latitude":
      if (!REGEX_CONSTANT.JUST_LAT.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 30 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "emergency_contact_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 100 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "emergency_contact_phone":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else if (data?.length > 13 || data?.length < 9) {
        error[namespace] = translate("Field cannot be less than 9 and more than 13", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "salary":
      if (data?.length > 20 || data?.length <= 1) {
        error[namespace] = translate(
          "Field Salary Characters cannot be less than 1 and more than 20",
          {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          }
        );
      } else {
        error[namespace] = null

      }
      break;

    case "driver_license_no":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 30 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "license_validity":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;

    case "emergency_contact_relationship":
      if (data?.length > 100) {
        error[namespace] = translate("Max character is 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "total_min":
      if (data < 0) {
        error[namespace] = translate("Shift start cannot bigger than shift end", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "driving_license_no":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 30) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "vehicle_type":
      if (data?.length > 20) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "model":
      if (data?.length > 20) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "vehicle_no":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 20) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null

      }
      break;
    case "min_order_unit":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "max_order_unit":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "min_order_weight":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "max_order_weight":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "min_order_volume":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "max_order_volume":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "fixed_cost":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "variable_cost":
      if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "transporter_time_cost":
      if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "waiting_time_cost":
      if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;
    case "day_off":
      if (typeof data === 'object' && data.length === 0) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (typeof data !== 'object') {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;

    case "license_type":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }
      break;

    case "vehicle_no_exp_date":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;

    case "temperature_category_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;

    case "skill_set":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null
      }
      break;

    case "shift_start_hour":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE");
      } 
      // else if(!REGEX_CONSTANT.INTEGER.test(data) || data.length < 2) {
      //   error[namespace] = translate("Invalid format", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } 
      // else if(data && (Number(data) > 23)){
      //   error[namespace] = "Max hours is 23";
      // }
      else {
        error[namespace] = null
      }
      break;

    case "shift_start_minute":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE");
      } 
      // else if(!REGEX_CONSTANT.INTEGER.test(data) || data.length < 2) {
      //   error[namespace] = translate("Invalid format", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } else if(data && (Number(data) > 59)){
      //   error[namespace] = "Max minutes is 59";
      // } 
      else {
        error[namespace] = null
      }
      break;

    case "shift_end_hour":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE");
      } 
      // else if(!REGEX_CONSTANT.INTEGER.test(data) || data.length < 2) {
      //   error[namespace] = translate("Invalid format", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } else if(data && (Number(data) > 23)){
      //   error[namespace] = "Max hours is 23";
      // }
       else {
        error[namespace] = null
      }
      break;

    case "shift_end_minute":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE");
      }
      //  else if(!REGEX_CONSTANT.INTEGER.test(data) || data.length < 2) {
      //   error[namespace] = translate("Invalid format", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // }  else if(data && (Number(data) > 59)){
      //   error[namespace] = "Max minutes is 59";
      // }
       else {
        error[namespace] = null
      }
      break;
      
    case "daily_salary":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE");
      } else if (data.length > 20) {
        error[namespace] = translate(
          "Field Salary Characters cannot be less than 1 and more than 20",
          {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          }
        );
      } else {
        error[namespace] = null;
      }
      break;

    default:
      break;
  }
  return error;
}